import * as React from 'react';

export interface IMenuLabelProps {
	isHidden?: boolean;
}

export default class MenuLabel extends React.Component<IMenuLabelProps, {}> {
	public render() {
		if (this.props.isHidden) {
			return null;
		}

		return <p className="menu-label">{this.props.children}</p>;
	}
}
